import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../constants/rentalPortal'
import {
  getViewingObjectName,
  getViewingTimeRangeLabel,
} from '../../RentalPortalViewing'
import {
  getApplicantChecklistRows,
  getApplicantDocumentStatusProps,
  getApplicantDocumentTypeLabel,
  getApplicantIdentityContactRows,
  getApplicantMatchingRows,
} from '../RentalPortalApplicantProfile'

export function getViewingApplicantPreviewSections({ applicantData, t }) {
  return [
    {
      key: 'contact',
      rows: getApplicantIdentityContactRows({ applicantData, t }).map(row => ({
        key: row.name,
        label: row.label,
        text: row.text,
      })),
      titleKey: 'RentalPortal.ApplicantProfileIdentityTitleKey',
    },
    {
      key: 'enquiry',
      rows: getApplicantMatchingRows({ applicantData, t }).map(row => ({
        key: row.key,
        label: row.label,
        text: row.value,
      })),
      titleKey: 'RentalPortal.ApplicantProfileMatchingTitleKey',
    },
    {
      key: 'documents',
      rows: getApplicantChecklistRows(applicantData).map(row => ({
        key: row.key,
        label: getApplicantDocumentTypeLabel({ row, t }),
        statusProps: getApplicantDocumentStatusProps({ row, t }),
      })),
      titleKey: 'RentalPortal.ApplicantProfileChecklistTitleKey',
    },
  ]
}

export function getViewingApplicantPreviewViewingLabel({
  locale,
  t,
  timezone,
  viewing,
}) {
  return [
    getViewingObjectName({ locale, t, timezone, viewing }),
    getViewingTimeRangeLabel({
      end: viewing.end,
      locale,
      start: viewing.start,
      timezone,
    }),
  ].join(RENTAL_PORTAL_FACT_SEPARATOR)
}
